import { ToastrService } from 'ngx-toastr';
import { Overlay } from '@angular/cdk/overlay';
import { Component, ViewChild, Inject, Input, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { OffersComponent } from '../offers/offers.component';
import { Router } from '@angular/router';
import { BsDatepickerConfig, BsDaterangepickerDirective, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { Location, DOCUMENT } from '@angular/common';
import * as moment from 'moment';
import * as locales from 'ngx-bootstrap/locale';
declare var $: any;
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RoomlistService } from 'modules/shared/legacy-bookexpress/services/RoomList.service';
import { OfferlistService } from 'modules/shared/legacy-bookexpress/services/OfferList.service';
import { SharedService } from 'modules/shared/legacy-bookexpress/services/shared.service';
import { PreloaderService } from 'modules/shared/legacy-bookexpress/services/preloader.service';
import { CasinoPlayerService } from 'modules/shared/legacy-bookexpress/services/casino-player.service';
import { CpinService } from 'modules/shared/legacy-bookexpress/services/cpin.service';
import { menuService } from 'modules/shared/legacy-bookexpress/services/menu.service';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { BookService } from 'modules/shared/legacy-bookexpress/services/book.service';
import { EventData, GoogleAnalyticsEventsService } from 'modules/shared/legacy-bookexpress/services/google-analytics-events.service';
import { MaintenanceService } from 'modules/shared/legacy-bookexpress/services/maintenance.service';
import { CurrencyService } from 'modules/shared/legacy-bookexpress/services/currency.service';
import { ValidateLoyaltyService } from 'modules/shared/legacy-bookexpress/services/validate-loyalty.service';
import { CryptoconvertService } from 'modules/shared/legacy-bookexpress/services/cryptoconvert.service';
import { StayenhanceService } from 'modules/shared/legacy-bookexpress/services/stay-enhance.service';
import { CpinComponent } from 'modules/shared/legacy-bookexpress/components/cpin/cpin.component';
import { PolicyModalComponent } from 'modules/shared/legacy-bookexpress/components/policy-modal/policy-modal.component';
import * as ADMIN_CONSTANT from 'app/shared/constants/admin-constants';
import { RGuestMessages } from 'app/model/shared/backend-api-response/rguest-messages';
import { DateFunctionConfig } from 'app/model/shared/backend-api-response/date-function-config';
import { Permissions } from 'app/model/shared/backend-api-response/permissions';
import { GetOfferApiResponse } from 'app/model/wbe/backend-api-response/get-offer-api-response';
import { GetAdvancedFilterDataResponse } from 'app/model/shared/backend-api-response/get-advanced-filter-data-response';
import { GetRoomsResponse } from 'app/model/wbe/backend-api-response/get-rooms-response';
import { Guid } from 'guid-typescript';
@Component({
  selector: 'bottom-sheet-rooms-filter',
  templateUrl: 'bottom-sheet-rooms-filter.html',
})
export class BottomSheetRoomFilter {
  filterForm: FormGroup;
  public filteredItems = [];
  public filtervalueObj = {};
  public filters: any;
  rGuestBookMessages: RGuestMessages;
  constructor(
    public _bottomSheetRoomFilterRef: MatDialogRef<BottomSheetRoomFilter>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    fb: FormBuilder,
    public roomService: RoomlistService
  ) {
    this.rGuestBookMessages = this.roomService?.CommonService?.PropertyData?.rGuestMessages;
    this.filters = this.data.filterParams;
    this.filters.sort(function (a, b) {
      return a.order - b.order;
    });
    this.filteredItems = Object.assign([], this.data.rooms);
    var formElements = {};
    this.filters.forEach((element) => {
      formElements[element.mappingField + element.order] = [''];
    });
    this.filterForm = fb.group(formElements);
    this._bottomSheetRoomFilterRef.afterClosed().subscribe(() => {
      this.data.comp(this.filtervalueObj);
    });
    this.filtervalueObj = this.data.filters;
  }
  closeFilter() {
    this._bottomSheetRoomFilterRef.close();
  }
  clearFilter() {
    this.filteredItems = this.data.rooms;
    this.roomService?.roomlistFilter.next(this.filteredItems);
    this.filtervalueObj = {};
    this.data.comp(this.filtervalueObj);
  }
  filterItem() {
    this.filteredItems = this.roomService?.filterRooms(this.filters, this.filtervalueObj, this.data.rooms);
    this.roomService?.roomlistFilter.next(this.filteredItems);
    this.data.comp(this.filtervalueObj);
  }
}

export class Roomdata {
  constructor(
    public expandedDescription,
    public blockRoom,
    public compDays,
    public days,
    public hasComp,
    public minRate,
    public minRateTax,
    public thead,
    public tbody,
    public roomsImages,
    public previousPlayerStay,
    public wing,
    public roomType,
    public roomCode,
    public roomName,
    public cancellationPolicy,
    public depositPolicy,
    public rateSnapshot,
    public roomTotal,
    public roomTaxTotal,
    public recurringChargesTotalTax,
    public quoteGrandTotal,
    public roomTypeAvailable,
    public roomSequence,
    public resortFeeTotalTax,
    public recurringChargesTotal,
    public cancelDescription,
    public depositDueDate,
    public resortFeeTotal,
    public depositAmountDue,
    public cancelAmountDue,
    public cancelDueDate,
    public quoteTotalTax,
    public depositDescription,
    public quoteTotal,
    public hasEnhancement,
    public recurringChargesEnhancementTotal,
    public resortFeeEnhancementTotal,
    public roomSoldOut,
    public showRemainingRoomsCount,
    public isPackage
  ) {}
}

@Component({
  selector: 'app-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.scss', './room-style-handler.component.scss'],
})
export class RoomComponent implements OnInit {
  objectKeys = Object.keys;
  objectValues = Object.values;
  @Input() currencyValue: Node;
  disabled: true;
  tenantId: any;
  propertyId: any;
  private sub: any;
  public assetsURL: any;
  arrDate: string;
  depDate: string;
  casinoNumber: string;
  casinoPlayerName: string;
  casinoRankCard: string;
  selected: any = 2;
  public roomCompareData: Array<any> = [];
  previousRoom: any;
  details_tab: boolean = false;
  minDate: any;
  maxDate: Date;
  dts: Array<any> = [];
  baseCasino: string;
  selectedTab: any;
  checkinBlockDays: any;
  fullscreenView: boolean = false;
  thead: Array<any> = [];
  scrollfix: number;
  tbody: Array<any> = [];
  maxNightsAllowed: any;
  bsConfig: Partial<BsDatepickerConfig>;
  offersTab: number = 0;
  room: Array<any> = [];
  errorPopup: string;
  backupDate: Array<any> = [];
  previousIndex: number;
  defaultHeight: number;
  validateCasino: boolean = false;
  triggerSidebar: boolean;
  recurringcharges: Array<any> = [];
  guestCount: Array<any> = [2, 3, 4];
  offerCode: string;
  showRemainingRoomsCount: boolean = false;
  rGuestBookMessages: RGuestMessages;
  rGuestBookRoutePermissions: Permissions;
  invalidDate: boolean = false;
  roomList: Array<any> = [];
  roomList1: Array<any> = [];
  disableRefine: boolean = false;
  passHeight: number;
  selectedOffer: any = {};
  roomImageList: Array<any> = [];
  newCurrency: string = 'fa-usd';
  arrDatePickerCard: any = 'arrDatePickerCard';
  depDatePickerCard: any = 'depDatePickerCard';
  defaultRoomImageURL: any;
  newRate: any = 1;
  colorTheme = 'theme-dark-blue ';
  propertyTime: any;
  windowWidth: any;
  isIE11 = !!(window as any).MSInputMethodContext && !!(document as any).documentMode;
  casinoValidateHide: boolean = false;
  initialValue: Array<any> = [];
  private selectedTabvalue;
  roomPreload: boolean;
  closedvalue: boolean = true;
  firstName: string = '';
  loginFromOffersData: boolean = false;
  getCasinoOfferAfterLogin: boolean = false;
  currencyCode: any;
  countryCode: any;
  lastName: string = '';
  public fixed: boolean = false;
  refineSearchGuestCount: any;
  subscription: any;
  preloadText: string;
  public IEarrival: any;
  public IEdeparture: any;
  public adultsValue: any;
  public childValue: any;
  public infantsValue: any;
  public juniorValue: any;
  public disablePeopleValue: any;
  preloadData: boolean = false;
  emptyFilterVisibility: boolean = false;
  dateRangePickerFormat: any;
  dateFunctionConfig: DateFunctionConfig;
  filtervalueobj: any = {};
  //Venetian TS change
  restrictedDates: Date[];
  restrictDateSelection: boolean = false; // Venetian TS change for now harcoding to true
  @ViewChild('offers') child: OffersComponent;
  @ViewChild('bottomSheetComponent') bottomSheetComponent: BottomSheetRoomFilter;
  @ViewChild(MatSidenavContainer) sidenavContainer: MatSidenavContainer;
  @ViewChild('compareRooms') compareRooms;
  @ViewChild('dpr1')
  private _picker: BsDaterangepickerDirective;
  @ViewChild('arrPicker')
  private arrDatePicker: MatDatepicker<Date>;
  @ViewChild('depPicker')
  private depDatePicker: MatDatepicker<Date>;
  @ViewChild('arrPicker1')
  private arrDatePicker1: MatDatepicker<Date>;
  @ViewChild('depPicker1')
  private depDatePicker1: MatDatepicker<Date>;
  @ViewChild('depositAndCancellationBtn') private depositAndCancellationBtn: ElementRef;
  //Added variables for cart limit
  cartSize = 0;
  disableCart: boolean = false;
  cartMsg: string;
  hasInvalidDates = false;
  public filteredItems: any = [];
  filteredchipsValues: any[];
  public filters: any[];
  public showFilterPanel: boolean = false;
  public showMore: any = false;
  public dateValueChanged: boolean = false;
  public disableCapitalizePipe: boolean = false;
  hideRateDepositAndCancelPoliciesIfSoldOut: boolean;

  constructor(
    private route: ActivatedRoute,
    private _roomList: RoomlistService,
    private _offers: OfferlistService,
    private _adapter: DateAdapter<any>,
    private router: Router,
    private _shared: SharedService,
    private toastr: ToastrService,
    public PreloaderService: PreloaderService,
    public CasinoPlayerService: CasinoPlayerService,
    public location: Location,
    public CpinService: CpinService,
    private overlay: Overlay,
    public menuService: menuService,
    public CommonService: LegacyBookInitService,
    public _offersList: OfferlistService,
    public BookService: BookService,
    public googleAnalyticsEventsService: GoogleAnalyticsEventsService,
    public MaintenanceService: MaintenanceService,
    public AppInitializer: LegacyBookInitService,
    private GetCurrencyService: CurrencyService,
    public validateloyaltyService: ValidateLoyaltyService,
    public cryptoConvert: CryptoconvertService,
    public snackbar: MatSnackBar,
    private ConfigService: LegacyBookInitService,
    public enhance: StayenhanceService,
    private localeService: BsLocaleService,
    private dialog: MatDialog
  ) {
    this.adultsValue = this.AppInitializer?.guestTypeLimit.findIndex((guest) => guest.key === 'adults');
    this.childValue = this.AppInitializer?.guestTypeLimit.findIndex((guest) => guest.key === 'children');
    this.infantsValue = this.AppInitializer?.guestTypeLimit.findIndex((guest) => guest.key === 'infants');
    this.juniorValue = this.AppInitializer?.guestTypeLimit.findIndex((guest) => guest.key === 'juniors');
    this.disablePeopleValue = this.AppInitializer?.guestTypeLimit.findIndex((guest) => guest.key === 'discChild');
    this.hideRateDepositAndCancelPoliciesIfSoldOut =
      this.AppInitializer?.PropertyData?.permissions?.functionalPermissions?.hideRateDepositAndCancelPoliciesIfSoldOut || false;

    if (this.AppInitializer?.PropertyData?.permissions?.functionalPermissions?.advancedFilter) {
      this._roomList.getAdvanceFilterData().subscribe((data: GetAdvancedFilterDataResponse) => {
        if (data['success']) {
          try {
            this.filters =
              data.advancedFilterConfig.length > 0 && data.advancedFilterConfig[0].filters ? data.advancedFilterConfig[0].filters : [];
          } catch (error) {
            this.filters = [];
          }
        }
      });
    }
    this.dateFunctionConfig = this.AppInitializer?.PropertyData?.dateFunctionConfig;
    this._adapter.setLocale(this.dateFunctionConfig?.dateRangePickerFormat);
    this.countryCode = this.ConfigService?.PropertyData?.countryCode;
    for (const locale in locales) {
      if (this.dateFunctionConfig?.dateRangePickerFormat === locales[locale].abbr) {
        this.localeService.use(this.dateFunctionConfig?.dateRangePickerFormat);
      }
    }
    this.rGuestBookMessages = this.AppInitializer?.PropertyData?.rGuestMessages;
    this.rGuestBookRoutePermissions = this.AppInitializer?.PropertyData?.permissions;
    this.getCasinoOfferAfterLogin = this.rGuestBookRoutePermissions?.functionalPermissions?.getCasinoOfferAfterLogin
      ? this.rGuestBookRoutePermissions?.functionalPermissions?.getCasinoOfferAfterLogin
      : this.getCasinoOfferAfterLogin;
    this.defaultRoomImageURL = this.AppInitializer?.PropertyData?.UrlMap?.defaultRoomImageUrl;
    this.disableCapitalizePipe =
      this.rGuestBookRoutePermissions?.functionalPermissions &&
      this.rGuestBookRoutePermissions?.functionalPermissions?.disableCapitalizePipe
        ? this.rGuestBookRoutePermissions?.functionalPermissions?.disableCapitalizePipe
        : false;
    this.assetsURL = this.ConfigService?.PropertyData?.UrlMap?.ImageUrl;
    this._roomList.offerSelectedfromoffersAPI.subscribe((offerSelectedfromoffersAPI) => {
      if (offerSelectedfromoffersAPI) {
        this.loginFromOffersData = false;
        this._roomList.offerSelectedfromoffersAPI.next(false);
      }
    });
    this.route.queryParams.subscribe((queryParams) => {
      if (this.AppInitializer?.multiGuestType) {
        if (this.AppInitializer?.guestTypeLimit[this.childValue]) {
          this.AppInitializer.guestTypeLimit[this.childValue].selectedValue = queryParams['children'];
        }
        if (this.AppInitializer?.guestTypeLimit[this.juniorValue]) {
          this.AppInitializer.guestTypeLimit[this.juniorValue].selectedValue = queryParams['juniors'];
        }
        if (this.AppInitializer?.guestTypeLimit[this.infantsValue]) {
          this.AppInitializer.guestTypeLimit[this.infantsValue].selectedValue = queryParams['infants'];
        }
        if (this.AppInitializer?.guestTypeLimit[this.disablePeopleValue]) {
          this.AppInitializer.guestTypeLimit[this.disablePeopleValue].selectedValue = queryParams['discChild'];
        }
      }
    });
    this.sub = this.route.params.subscribe((params) => {
      (this.tenantId = params['tenant']),
        (this.propertyId = params['property']),
        (this.arrDate = params['arrival']),
        (this.depDate = params['departure']),
        (this.offerCode = params['offer']),
        (this.selected = params['guest']);
      if (this.AppInitializer?.multiGuestType) {
        this.AppInitializer.guestTypeLimit[this.adultsValue].selectedValue = params['guest'];
      }
      let arrDate = this.arrDate.split('-');
      let depDate = this.depDate.split('-');
      this.IEarrival = new Date(+arrDate[0], +arrDate[1] - 1, +arrDate[2]);
      this.IEdeparture = new Date(+depDate[0], +depDate[1] - 1, +depDate[2]);
      if (this.rGuestBookRoutePermissions?.functionalPermissions?.encryptOfferCodeinURL)
        this.offerCode = this.cryptoConvert.convertOfferCode(this.offerCode, 'decrypt');
      this.menuService.routeChange(params);
      this._shared.updateTenant(this.tenantId, this.propertyId);
      this.afterInit();
      this.googleAnalyticsEventsService.eventEmitter(
        'page_load',
        'room',
        'room_page_loaded',
        `Rooms page Loaded, Casino Id - ${this.validateloyaltyService.playerDetails?.casinoNumber || 'NA'}, Offer Code - ${this.offerCode}`
      );

      this.googleAnalyticsEventsService.eventEmitter(
        'offer_selected',
        'room',
        'offer_click',
        `Offer Code -${this.offerCode}_selected, Casino Id - ${this.validateloyaltyService.playerDetails?.casinoNumber || 'NA'}`
      );
    });
    const dateFormat = moment.localeData(this.dateFunctionConfig?.locale).longDateFormat('L');
    this.bsConfig = Object.assign(
      {},
      { containerClass: this.colorTheme, displayMonths: 1, rangeInputFormat: dateFormat, rangeSeparator: ' - ', showWeekNumbers: false }
    );
    this.CasinoPlayerService.resetPlayernew.subscribe((cas) => {
      if (cas != 'default') {
        this.casinoNumber = '';
        this.baseCasino = '';
        this.casinoPlayerName = null;
        this.casinoRankCard = null;
      }
    });
    this._roomList.roomlistFilter.subscribe((data) => {
      if (data != 'none') {
        this.filteredItems = data;
        this.checkViewPort();
      }
    });
  }

  getGuestDetails(detail, val) {
    detail.selectedValue = val.value;
    this.refineSearchGuestCount = 0;
    this.AppInitializer?.guestTypeLimit.forEach((element) => {
      if (element.selectedValue) {
        this.refineSearchGuestCount += Number(element.selectedValue);
      }
    });
    if (this.rGuestBookRoutePermissions?.functionalPermissions?.enableAutoSearch) {
      this.refineSearch();
    }
  }

  guestDetailsChanged() {
    if (this.rGuestBookRoutePermissions?.functionalPermissions?.enableAutoSearch) {
      this.refineSearch();
    }
  }

  onShowPicker(event) {
    const dayHoverHandler = event.dayHoverHandler;
    let arrivalDate, departureDate;
    const hoverWrapper = (hoverEvent) => {
      const { cell, isHovered } = hoverEvent;

      if (isHovered && !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && 'ontouchstart' in window) {
        console.log(cell);
        if (!arrivalDate) arrivalDate = cell.date;
        else {
          if (moment(cell.date).isAfter(moment(arrivalDate))) {
            departureDate = cell.date;
            setTimeout(() => {
              (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
            }, 100);
          } else {
            arrivalDate = cell.date;
          }
        }
      } else {
        return dayHoverHandler(hoverEvent);
      }
      if (arrivalDate && departureDate) return dayHoverHandler(hoverEvent);
    };
    event.dayHoverHandler = hoverWrapper;
  }

  ngOnInit() {
    this.restrictDateSelection = this.AppInitializer?.PropertyData?.permissions?.functionalPermissions?.restrictDateSelectionBasedOnTier; //Venetian TS changes
    this.restrictedDates = this.validateloyaltyService.restrictedDateArray;
    this.filteredItems = [];
    this.filtervalueobj = [];
    this.showFilterPanel = false;
    this.restrictDatesOffer(); //Venetian TS changes
    //Google Tag Manager push
    this.googleAnalyticsEventsService.pushGTAToDataLayer({
      event: 'roomsPageLoad',
      page: this.rGuestBookMessages?.menuBar?.menuNames_menuRoomsandRates,
      casinoId: this.validateloyaltyService.playerDetails?.casinoNumber || 'NA',
      emailAddress: this.validateloyaltyService.playerDetails?.emailAddress || 'NA',
      'Promo Code': this.offerCode,
    });

    this.googleAnalyticsEventsService.eventEmitter(
      'page_load',
      'room',
      'room_page_loaded',
      `Room Page Loaded, Casino Id. -${this.validateloyaltyService?.playerDetails?.casinoNumber || 'NA'}, Email Address- ${
        this.validateloyaltyService.playerDetails?.emailAddress || 'NA'
      }, OfferCode - ${this.offerCode}`
    );
  }

  afterInit() {
    this.hasInvalidDates = false;
    console.log('Dates from URL is: ', this.arrDate, this.depDate);
    this.casinoNumber = '';
    this.baseCasino = '';
    setTimeout(() => {
      $('#gotores').removeClass('active');
    }, 500);
    this.CpinService.loginPlayerDetails.subscribe((cres) => {
      if (cres != 'default') {
        this.casinoNumber = cres.casinoNumber;
        this.casinoValidateHide = true;
      }
    });
    this.processConfig(this.CommonService?.configDetailsData);
    if (
      typeof localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'Casino') != 'undefined' &&
      JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'Casino')) != null
    ) {
      let casinoDetails = JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'Casino'));
      this.casinoNumber = casinoDetails.casinoNumber;
      this.baseCasino = casinoDetails.casinoNumber;
    }

    this.CasinoPlayerService.userData$.subscribe((result) => {
      if (result != 'data') {
        console.log('casino Data updated');
        this.casinoPlayerName = result.firstName + ' ' + result.lastName;
        //this.casinoRankCard = result['rank'].lmsRank;
        let lmsRank = result['rank'] && result['rank'].lmsRank ? result['rank'].lmsRank : null;
        let lmsTier = result['tier'] && result['tier'].lmsTier ? result['tier'].lmsTier : null;
        if (lmsRank && !lmsTier) {
          this.casinoRankCard = lmsRank;
        } else if (!lmsRank && lmsTier) {
          this.casinoRankCard = lmsTier;
        } else if (lmsRank && lmsTier) {
          this.casinoRankCard = this.rGuestBookRoutePermissions?.functionalPermissions?.displayPlayerImageBasedOnTier ? lmsTier : lmsRank;
        } else if (!lmsRank && !lmsTier) {
          this.casinoRankCard = '';
        }
        this.casinoValidateHide = true;
        this.firstName = result.firstName;
        this.lastName = result.lastName;
      } else {
        this.casinoValidateHide = false;
        this.casinoPlayerName = '';
        this.casinoRankCard = '';
        this.casinoNumber = '';
        this.firstName = '';
        this.lastName = '';
      }
    });
    if (this.AppInitializer?.guestLoginFlow === 'SSO') {
      this.validateloyaltyService.casinoPlayerDetails.subscribe((result) => {
        if (result != 'default') {
          console.log('casino Data updated');
          this.casinoPlayerName = result['firstName'] + ' ' + result['lastName'];
          //this.casinoRankCard = result['rank'].lmsRank;
          let lmsRank = result['rank'] && result['rank'].lmsRank ? result['rank'].lmsRank : null;
          let lmsTier = result['tier'] && result['tier'].lmsTier ? result['tier'].lmsTier : null;
          if (lmsRank && !lmsTier) {
            this.casinoRankCard = lmsRank;
          } else if (!lmsRank && lmsTier) {
            this.casinoRankCard = lmsTier;
          } else if (lmsRank && lmsTier) {
            this.casinoRankCard = this.rGuestBookRoutePermissions?.functionalPermissions?.displayPlayerImageBasedOnTier ? lmsTier : lmsRank;
          } else if (!lmsRank && !lmsTier) {
            this.casinoRankCard = '';
          }
          this.casinoValidateHide = true;
          this.firstName = result['firstName'];
          this.lastName = result['lastName'];
        } else {
          this.casinoValidateHide = false;
          this.casinoPlayerName = '';
          this.casinoRankCard = '';
          this.casinoNumber = '';
          this.firstName = '';
          this.lastName = '';
        }
      });
    }
    this.GetCurrencyService.currentMessage.subscribe((result) => {
      if (result == 'USD') {
        this.newRate = 1;
        this.newCurrency = 'fa-usd';
      } else {
        this.newCurrency = result['fonticon'];
        this.newRate = result['currencyValue'];
        this.currencyCode = result['currencyCode'];
        this.countryCode = result['countryCode'];
      }
    });

    this._shared.data$.subscribe((result) => {
      this.cartSize = result.length;
      if (this.cartSize >= this.AppInitializer?.cartLimit) {
        this.disableCart = true;
        this.cartMsg =
          this.rGuestBookMessages?.cart.cartMessage9 + this.AppInitializer?.cartLimit + this.rGuestBookMessages?.cart.cartMessage10;
      } else if (this.cartSize < this.AppInitializer?.cartLimit) {
        this.disableCart = false;
      }
    });
    if (!moment(this.arrDate, 'YYYY-MM-DD', true).isValid() || !moment(this.depDate, 'YYYY-MM-DD', true).isValid()) {
      this.roomImageList = [];
      this.roomList = [];
      this.filteredItems = [];
      this.roomList1 = [];
      this.hasInvalidDates = true;
      this.invalidDate = true;
      this.errorPopup =
        this.rGuestBookMessages?.rooms.roomsPageInvalidDateMessage ||
        'Please select Arrival and Departure and click Refine Search to View Rooms.';
      setTimeout(() => {
        var windowHeight = $(window).height();
        var header = $('#headerItem').outerHeight();
        var roomData = $('#scrollingItem').outerHeight();
        console.log(windowHeight, header, roomData);

        if (windowHeight > header + roomData) {
          console.log('Height modification required');
          this.fullscreenView = true;
        } else {
          console.log('Height modification not required');
          this.fullscreenView = false;
        }
      }, 1000);
    } else if (moment(this.arrDate).isSame(moment(this.depDate))) {
      this.PreloaderService.sendData({ value: 'No preload', status: false });
      let errordate = this.rGuestBookMessages?.rooms.arrDepSameErrorMessage || 'Arrival Date and Departure Date should not be same';
      this.errorPopup = errordate;
      this.disableRefine = true;
      console.log('going out');
    } else {
      let data = {
        status: true,
        value: this.rGuestBookMessages?.rooms.roomMessage2,
      };
      this.PreloaderService.sendData(data);
      $(window).on('load, resize', function () {
        var viewportWidth = $(window).width();
        if (viewportWidth < 500) {
          $('.mobile-head-rate').addClass('col-xs-12');
          $('.mobile-head-rate').removeClass('pull-right');
        } else {
          $('.mobile-head-rate').addClass('pull-right');
          $('.mobile-head-rate').removeClass('col-xs-12');
        }
      });
      this.roomImageList = [];
      this.roomList = [];
      this.filteredItems = [];
      this.roomList1 = [];
      if (!this.PreloaderService.preloadStatus) {
        let data = {
          status: true,
          value: this.rGuestBookMessages?.rooms.roomMessage2,
        };
        this.PreloaderService.sendData(data);
      }
      console.log('casinoOffersParam: ', this._roomList.casinoPlayerloginCall.value);

      if (this.getCasinoOfferAfterLogin && this.casinoNumber && !this._roomList.casinoPlayerloginCall.value && !this.loginFromOffersData) {
        this._roomList.casinoPlayerloginCall.next(true);
        let offerinAPI = 'NA';
        let sessionOffer = sessionStorage.getItem(this.tenantId + '-' + this.propertyId + '-userSelectedOffer');
        if (sessionOffer && sessionOffer.length > 0) {
          offerinAPI = sessionOffer;
        }
        this._offersList.getsingleOffers('', '', '', this.arrDate, this.depDate, offerinAPI, this.casinoNumber, true).subscribe(
          (result: GetOfferApiResponse) => {
            if (result['Success']) {
              if (result['offers'].length > 0) {
                sessionStorage.setItem(this.tenantId + '-' + this.propertyId + '-userSelectedOffer', result['offers'][0].offer);
              }
            }
            this.processOffer(result);
          },
          (error) => {
            this.toastr.error(this._offersList.errorMessage);
          }
        );
      } else {
        this._offersList.getsingleOffers('', '', '', this.arrDate, this.depDate, this.offerCode, this.casinoNumber, '').subscribe(
          (result: GetOfferApiResponse) => {
            this.processOffer(result);

            if (result['Success'] && this.getCasinoOfferAfterLogin && this.casinoNumber) {
              if (result['offers'].length > 0) {
                sessionStorage.setItem(this.tenantId + '-' + this.propertyId + '-userSelectedOffer', result['offers'][0].offer);
              }
            }
          },
          (error) => {
            this.toastr.error(this._offersList.errorMessage);
          }
        );
      }

      this.roomImageList = [];
      this.roomList = [];
      this.filteredItems = [];
      this.roomList1 = [];
      if (!this.PreloaderService.preloadStatus) {
        this.PreloaderService.sendData({ value: 'No preload', status: false });
        let data = {
          status: true,
          value: this.rGuestBookMessages?.rooms.roomMessage2,
        };
        this.PreloaderService.sendData(data);
      }
      this.errorPopup = '';
      let arr = this.arrDate.split('-');
      let dep = this.depDate.split('-');
      this.initialValue = [new Date(+arr[0], +arr[1] - 1, +arr[2]), new Date(+dep[0], +dep[1] - 1, +dep[2])];
      this.formatDates();
      this.backupDate = this.initialValue;
      let guestMaxCount = this.AppInitializer?.multiGuestType ? this.AppInitializer?.guestTypeLimit[this.adultsValue]['maxCount'] : 4;
      if (dep < arr) {
        let errordate = this.rGuestBookMessages?.rooms.roomMessage1;
        this.errorPopup = errordate;
        //this.toastr.error(errordate);
        this.PreloaderService.sendData({ value: 'No preload', status: false });
      } else if (Number(this.selected) > Number(guestMaxCount) || Number(this.selected) == 0) {
        this.errorPopup = this.rGuestBookMessages?.rooms.roomMessage3;
        this.PreloaderService.sendData({ value: 'No preload', status: false });
      } else {
        console.log('Fetching rates');
        this.validateloyaltyService.casinoPlayerDetails.subscribe((data1) => {
          if (data1 != 'default') {
            this.casinoNumber = data1['casinoNumber'];
            this.firstName = data1['firstName'];
            this.lastName = data1['lastName'];
          }
        });
        if (!this.getCasinoOfferAfterLogin) {
          this.getRooms();
        }
      }
    }
    window.scrollTo(0, 0);
    //  this.snackbar.dismiss();
  }
  getRooms() {
    this.errorPopup = '';

    let setRoomValue: any;
    if (this.AppInitializer?.multiGuestType) {
      setRoomValue = this.AppInitializer?.guestTypeLimit;
    } else {
      setRoomValue = this.selected;
    }
    let offerCode = this.offerCode;
    if (this.rGuestBookRoutePermissions?.functionalPermissions?.encryptOfferCodeinURL) {
      this.offerCode = this.cryptoConvert.convertOfferCode(this.route.snapshot.paramMap.get('offer'), 'decrypt');
      offerCode = this.offerCode;
    }
    console.log('OFFER: ', this.route.snapshot.paramMap.get('offer'));
    this._roomList
      .getRooms(
        this.arrDate,
        this.depDate,
        offerCode,
        this.casinoNumber,
        setRoomValue,
        this.firstName,
        this.lastName,
        this.AppInitializer?.multiGuestType
      )
      .subscribe(
        (result: GetRoomsResponse) => {
          this.processRoom(result);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  loginFromOffers(e) {
    this.loginFromOffersData = e;
  }
  //  this.snackbar.dismiss();

  AddToCart(room, k) {
    this.getAnalyticsData(room);
    //Store Transaction ID locally
    if (
      typeof localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'transactionID') != 'undefined' &&
      JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'transactionID')) != null
    ) {
    } else {
      localStorage.setItem(
        this.tenantId + '-' + this.propertyId + '-' + 'transactionID',
        JSON.stringify(this.AppInitializer?.transactionID)
      );
    }

    let taxesAndFees;

    try {
      taxesAndFees = room.quoteTotalTax + room.recurringChargesTotal + room.resortFeeTotal;
    } catch (error) {
      taxesAndFees = room.quoteTotalTax;
    }

    // let totalGuestCount = 0;
    // this.AppInitializer?.guestDetails.forEach(element => {
    //   if(element.selectedValue){
    //   totalGuestCount += Number(element.selectedValue);
    //   }
    // });

    //Google Tag Manager Data Layer Push
    if (this.AppInitializer?.multiGuestType) {
      this.googleAnalyticsEventsService.pushGTAToDataLayer({
        event: 'roomPageData',
        value: room.quoteGrandTotal,
        transaction_id: 'NA',
        casinoId: this.validateloyaltyService.playerDetails?.casinoNumber || 'NA',
        emailAddress: this.validateloyaltyService.playerDetails?.emailAddress || 'NA',
        'Number of Nights': moment(this.depDate).diff(moment(this.arrDate), 'days'),
        Adults: this.AppInitializer?.guestTypeLimit[this.adultsValue].selectedValue
          ? this.AppInitializer?.guestTypeLimit[this.adultsValue].selectedValue
          : 1,
        'Check In Date': this.arrDate,
        'Check Out Date': this.depDate,
        'Total Revenue': room.quoteGrandTotal,
        'Room Type': room.roomType ? room.roomType : 'NA',
        Children: this.AppInitializer?.guestTypeLimit[this.childValue]
          ? this.AppInitializer?.guestTypeLimit[this.childValue].selectedValue
            ? this.AppInitializer?.guestTypeLimit[this.childValue].selectedValue
            : 0
          : 0,
        Juniors: this.AppInitializer?.guestTypeLimit[this.juniorValue]
          ? this.AppInitializer?.guestTypeLimit[this.juniorValue].selectedValue
            ? this.AppInitializer?.guestTypeLimit[this.juniorValue].selectedValue
            : 0
          : 0,
        Infants: this.AppInitializer?.guestTypeLimit[this.infantsValue]
          ? this.AppInitializer?.guestTypeLimit[this.infantsValue].selectedValue
            ? this.AppInitializer?.guestTypeLimit[this.infantsValue].selectedValue
            : 0
          : 0,
        'Disable people': this.AppInitializer?.guestTypeLimit[this.disablePeopleValue]
          ? this.AppInitializer?.guestTypeLimit[this.disablePeopleValue].selectedValue
            ? this.AppInitializer?.guestTypeLimit[this.disablePeopleValue].selectedValue
            : 0
          : 0,
        'Room Revenue': room.roomTotal,
        'Taxes and Fees': taxesAndFees,
        'Promo Code': this.offerCode,
        'Discount Amount': 'NA',
        'Reservation ID': 'NA',
        Currency: this.ConfigService?.PropertyData?.currencyCode,
        'Rate Plan': this.offerCode,
        'Property Booked': this.ConfigService?.configDetailsData.propertyName,
      });
    } else {
      this.googleAnalyticsEventsService.pushGTAToDataLayer({
        event: 'roomPageData',
        value: room.quoteGrandTotal,
        transaction_id: 'NA',
        casinoId: this.validateloyaltyService.playerDetails?.casinoNumber || 'NA',
        emailAddress: this.validateloyaltyService.playerDetails?.emailAddress || 'NA',
        'Number of Nights': moment(this.depDate).diff(moment(this.arrDate), 'days'),
        Adults: this.selected,
        'Check In Date': this.arrDate,
        'Check Out Date': this.depDate,
        'Total Revenue': room.quoteGrandTotal,
        'Room Type': room.roomType ? room.roomType : 'NA',
        Children: 0,
        'Room Revenue': room.roomTotal,
        'Taxes and Fees': taxesAndFees,
        'Promo Code': this.offerCode,
        'Discount Amount': 'NA',
        'Reservation ID': 'NA',
        Currency: this.ConfigService?.PropertyData?.currencyCode,
        'Rate Plan': this.offerCode,
        'Property Booked': this.ConfigService?.configDetailsData.propertyName,
      });
    }

    var cart = $('.cart-shake');
    var imgtodrag = $('.img-slide').find('img').eq(0);
    try {
      if (imgtodrag) {
        var imgclone = imgtodrag
          .clone()
          .offset({
            top: imgtodrag.offset().top,
            left: imgtodrag.offset().left,
          })
          .css({
            opacity: '0.5',
            position: 'absolute',
            height: '150px',
            width: '150px',
            'z-index': '99999',
          })
          .appendTo($('body'))
          .animate(
            {
              top: cart.offset().top + 10,
              left: cart.offset().left + 10,
              width: 75,
              'z-index': 99999,
              height: 75,
            },
            2000,
            'easeInOutExpo'
          );

        setTimeout(function () {
          cart.effect(
            'shake',
            {
              times: 2,
            },
            200
          );
        }, 1500);

        imgclone.animate(
          {
            width: 0,
            height: 0,
          },
          function () {
            $(this).detach();
          }
        );
      }
    } catch (e) {
      this.toastr.success(room.roomName.trim() + ' ' + this.rGuestBookMessages?.rooms.addToCartToastMessage.trim(), null, {
        timeOut: 4000,
      });
    }
    if (this.rGuestBookRoutePermissions?.routePermissions.enhancements) {
      let guest;
      if (this.offerCode != 'undefined' && this.arrDate != 'undefined' && this.depDate != 'undefined') {
        if (this.AppInitializer?.multiGuestType) {
          guest = this.AppInitializer?.guestTypeLimit;
        } else {
          guest = this.selected;
        }
        this.enhance
          .getConfigDetails(this.offerCode, this.arrDate, this.depDate, guest, this.AppInitializer?.multiGuestType, room.roomCode)
          .subscribe(
            (result) => {
              this.ProcessCartData(result, room);
            },
            (error) => {
              this.ProcessCartData(error, room);
            }
          );
      }
    } else {
      room.hasEnhancement = false;
      localStorage.setItem(this.tenantId + '-' + this.propertyId + '-' + 'validEnhancedata', 'false');
      let roomDetail = new Roomdata(
        room.expandedDescription,
        room.blockRoom,
        room.compDays,
        room.days,
        room.hasComp,
        room.minRate,
        room.minRateTax,
        room.thead,
        room.tbody,
        room.roomsImages,
        room.previousPlayerStay,
        room.wing,
        room.roomType,
        room.roomCode,
        room.roomName,
        room.cancellationPolicy,
        room.depositPolicy,
        room.rateSnapshot,
        room.roomTotal,
        room.roomTaxTotal,
        room.recurringChargesTotalTax,
        room.quoteGrandTotal,
        room.roomTypeAvailable,
        room.roomSequence,
        room.resortFeeTotalTax,
        room.recurringChargesTotal,
        room.cancelDescription,
        room.depositDueDate,
        room.resortFeeTotal,
        room.depositAmountDue,
        room.cancelAmountDue,
        room.cancelDueDate,
        room.quoteTotalTax,
        room.depositDescription,
        room.quoteTotal,
        room.hasEnhancement,
        room.recurringChargesEnhancementTotal,
        room.resortFeeEnhancementTotal,
        room.roomSoldOut,
        this.showRemainingRoomsCount,
        room.isPackage
      );
      roomDetail.thead.forEach((element) => {
        if (element == 'roomTheadResortFee') {
          roomDetail['hasResortFee'] = true;
        }
        if (element == 'roomTheadOtherFee') {
          roomDetail['hasOtherFee'] = true;
        }
      });
      this.BookService.putValue(
        roomDetail,
        this.arrDate,
        this.depDate,
        this.casinoNumber,
        this.offerCode,
        this.thead,
        this.AppInitializer?.multiGuestType,
        this.AppInitializer?.multiGuestType ? this.AppInitializer?.guestTypeLimit : this.selected,
        '',
        this.selectedOffer,
        this.tenantId,
        this.propertyId,
        ''
      );
    }
  }
  ProcessCartData(data, room) {
    let tenant = this.tenantId;
    let property = this.propertyId;
    if (data.Success == false) {
      room.hasEnhancement = false;
      if (localStorage.getItem(tenant + '-' + property + '-' + 'validEnhancedata')) {
        let value = localStorage.getItem(tenant + '-' + property + '-' + 'validEnhancedata');
        if (value == 'false') {
          localStorage.setItem(tenant + '-' + property + '-' + 'validEnhancedata', 'false');
        } else {
          localStorage.setItem(tenant + '-' + property + '-' + 'validEnhancedata', 'true');
        }
      } else localStorage.setItem(tenant + '-' + property + '-' + 'validEnhancedata', 'false');
    } else {
      if (data.enhancements.length > 0) {
        room.hasEnhancement = true;
        localStorage.setItem(tenant + '-' + property + '-' + 'validEnhancedata', 'true');
      } else {
        room.hasEnhancement = false;
        localStorage.setItem(tenant + '-' + property + '-' + 'validEnhancedata', 'false');
      }
    }
    let enhanceData = data;
    enhanceData.roomName = room.roomName;
    enhanceData.offerName = this.selectedOffer.offerDescription;
    enhanceData.offerCode = this.offerCode;
    enhanceData.ArrivalDate = this.arrDate;
    enhanceData.DepartureDate = this.depDate;

    let roomDetail = new Roomdata(
      room.expandedDescription,
      room.blockRoom,
      room.compDays,
      room.days,
      room.hasComp,
      room.minRate,
      room.minRateTax,
      room.thead,
      room.tbody,
      room.roomsImages,
      room.previousPlayerStay,
      room.wing,
      room.roomType,
      room.roomCode,
      room.roomName,
      room.cancellationPolicy,
      room.depositPolicy,
      room.rateSnapshot,
      room.roomTotal,
      room.roomTaxTotal,
      room.recurringChargesTotalTax,
      room.quoteGrandTotal,
      room.roomTypeAvailable,
      room.roomSequence,
      room.resortFeeTotalTax,
      room.recurringChargesTotal,
      room.cancelDescription,
      room.depositDueDate,
      room.resortFeeTotal,
      room.depositAmountDue,
      room.cancelAmountDue,
      room.cancelDueDate,
      room.quoteTotalTax,
      room.depositDescription,
      room.quoteTotal,
      room.hasEnhancement,
      room.recurringChargesEnhancementTotal,
      room.resortFeeEnhancementTotal,
      room.roomSoldOut,
      this.showRemainingRoomsCount,
      room.isPackage
    );
    roomDetail.thead.forEach((element) => {
      if (element == 'roomTheadResortFee') {
        roomDetail['hasResortFee'] = true;
      }
      if (element == 'roomTheadOtherFee') {
        roomDetail['hasOtherFee'] = true;
      }
    });
    this.BookService.putValue(
      roomDetail,
      this.arrDate,
      this.depDate,
      this.casinoNumber,
      this.offerCode,
      this.thead,
      this.AppInitializer?.multiGuestType,
      this.AppInitializer?.multiGuestType ? this.AppInitializer?.guestTypeLimit : this.selected,
      '',
      this.selectedOffer,
      this.tenantId,
      this.propertyId,
      enhanceData
    );
  }

  setHeight(data) {
    this.defaultHeight = data;
  }
  setWidth(data) {
    this.windowWidth = data;
  }
  checkViewPort() {
    var viewportWidth = $(window).width();
    setTimeout(() => {
      if (viewportWidth < 500) {
        $('.mobile-head-rate').addClass('col-xs-12');
        $('.mobile-head-rate').removeClass('pull-right');
      } else {
        $('.mobile-head-rate').addClass('pull-right');
        $('.mobile-head-rate').removeClass('col-xs-12');
      }
    }, 200);
    console.log(viewportWidth);
  }
  private processRoom = (room) => {
    this.checkViewPort();
    this.errorPopup = '';
    this.filteredItems = [];
    this.filtervalueobj = [];
    this.showFilterPanel = false;
    this.restrictDatesOffer();
    if (room.Success == true) {
      $('html').css('overflow', 'auto');
      //   $('body').css('overflow', 'auto');
      this.BookService.changeOffer(this.selectedOffer.offerDescription);
      this.showRemainingRoomsCount = room.offers[0].showRemainingRoomsCount;
      this.roomList = room.offers[0].roomTypes;
      this._roomList.roomlistFilter.next(this.roomList);
      for (let p = 0; p < this.roomList.length; p++) {
        this.roomCompareData[p] = {
          roomName: this.roomList[p].roomName,
          roomCode: this.roomList[p].roomCode,
          minRate: this.roomList[p].minRate,
        };
      }
      this.googleAnalyticsEventsService.viewRoomList(
        room,
        this.validateloyaltyService?.playerDetails?.casinoNumber,
        this.ConfigService?.configDetailsData.propertyName,
        this.ConfigService?.PropertyData?.currencyCode,
        this.propertyId
      );
      console.log(this.roomList);
      console.log('Path: ', this.route.snapshot.url[0].path, this.router.url, this.location.path());
      var loc = this.location.path();
      if (loc.startsWith('/wbe/room')) {
        this.PreloaderService.sendData({ value: 'No preload', status: false });
      }

      setTimeout(() => {
        var windowHeight = $(window).height();
        var header = $('#headerItem').outerHeight();
        var roomData = $('#scrollingItem').outerHeight();
        console.log(windowHeight, header, roomData);

        if (windowHeight > header + roomData) {
          console.log('Height modification required');
          this.fullscreenView = true;
        } else {
          console.log('Height modification not required');
          this.fullscreenView = false;
        }
      }, 1000);

      window.scrollTo(0, 0);
    } else {
      this.PreloaderService.sendData({ value: 'No preload', status: false });
      this.disableRefine = true;
      if (room.ErrorMessage) {
        this.errorPopup = room.ErrorMessage;
      } else if (room.messages && room.messages[0]) {
        this.errorPopup = room.messages[0].messageText;
      } else {
        this.errorPopup = this.rGuestBookMessages?.rooms?.RoomNotAvailableErrorMsg || 'Room not available';
      }
      setTimeout(() => {
        var windowHeight = $(window).height();
        var header = $('#headerItem').outerHeight();
        var roomData = $('#scrollingItem').outerHeight();
        console.log(windowHeight, header, roomData);

        if (windowHeight > header + roomData) {
          console.log('Height modification required');
          this.fullscreenView = true;
        } else {
          console.log('Height modification not required');
          this.fullscreenView = false;
        }
      }, 1000);
    }
  };

  refineSearch(opt?) {
    if (!opt) {
      this.selectedTabvalue = 0;
      this.filteredItems = [];
      this.showFilterPanel = false;
      this.errorPopup = '';
      $('#filter-model').modal('hide');
      $('#showArrow' + this.scrollfix).css('display', 'none');
      $('#detailstab').insertAfter($('#scrollingItem'));
      setTimeout(() => {
        var windowHeight = $(window).height();
        var header = $('#headerItem').outerHeight();
        var roomData = $('#scrollingItem').outerHeight();
        console.log(windowHeight, header, roomData);

        if (windowHeight > header + roomData) {
          console.log('Height modification required');
          this.fullscreenView = true;
        } else {
          console.log('Height modification not required');
          this.fullscreenView = false;
        }
      }, 100);
      this.details_tab = false;
    }
    if (Array.isArray(this.initialValue)) {
      if (this.initialValue.length > 1) {
        let ArrivalDate: Date = this.initialValue[0];
        let DepartureDate: Date = this.initialValue[1];
        ArrivalDate = new Date(ArrivalDate);
        let ArrDate = this.getDates(ArrivalDate);
        DepartureDate = new Date(DepartureDate);
        let DepDate = this.getDates(DepartureDate);
        var outArrivalDate = ArrDate;
        var outDepartureDate = DepDate;
        let sameDate = false;
        if (outDepartureDate == this.depDate && outArrivalDate == this.arrDate) {
          sameDate = true;
        }
        if (this.validateOffsetDaysOverlap(ArrivalDate, DepartureDate) == true) {
          let errordate =
            this.rGuestBookMessages?.rooms.offsetDaysErrorMessage ||
            'Dates overlap unavailable dates. Please select different Arrival and Departure Date and Refine Search.';
          this.errorPopup = errordate;
          return;
        } else {
          this.errorPopup = '';
        }
        // if (sameDate == false) {
        this.arrDate = outArrivalDate;
        this.depDate = outDepartureDate;
        // let arrDate = this.arrDate.split("-");
        // let depDate = this.depDate.split("-");
        // this.IEarrival = new Date(+arrDate[0], (+arrDate[1]) - 1, +arrDate[2])
        // this.IEdeparture = new Date(+depDate[0], (+depDate[1]) - 1, +depDate[2])
        let offerCode = this.offerCode;

        if (this.rGuestBookRoutePermissions?.functionalPermissions?.encryptOfferCodeinURL) {
          this.offerCode = this.cryptoConvert.convertOfferCode(this.route.snapshot.paramMap.get('offer'), 'decrypt');
          offerCode = this.route.snapshot.paramMap.get('offer');
        }
        console.log('OFFER: ', this.route.snapshot.paramMap.get('offer'));
        if (this.AppInitializer?.multiGuestType) {
          let parameterObj = {};
          this.AppInitializer?.guestTypeLimit.forEach((element) => {
            if (element['selectedValue'] && Number(element['selectedValue']) > 0 && element['key'] !== 'adults') {
              parameterObj[element['key']] = element['selectedValue'];
            }
          });
          this.router.navigate(
            [
              'wbe/room',
              this.tenantId,
              this.propertyId,
              this.arrDate,
              this.depDate,
              offerCode,
              this.AppInitializer?.guestTypeLimit[this.adultsValue].selectedValue
                ? this.AppInitializer?.guestTypeLimit[this.adultsValue].selectedValue
                : 1,
            ],
            { queryParams: parameterObj }
          );
        } else {
          this.router.navigate(['wbe/room', this.tenantId, this.propertyId, this.arrDate, this.depDate, offerCode, this.selected]);
        }
        this.afterInit();
      } else {
        this.roomImageList = [];
        this.roomList = [];
        this.filteredItems = [];
        this.roomList1 = [];
        this.PreloaderService.sendData({ value: 'No preload', status: false });
        this.hasInvalidDates = true;
        this.invalidDate = true;
        this.errorPopup =
          this.rGuestBookMessages?.rooms.roomsPageInvalidDateMessage ||
          'Please select Arrival and Departure and click Refine Search to View Rooms.';
        setTimeout(() => {
          var windowHeight = $(window).height();
          var header = $('#headerItem').outerHeight();
          var roomData = $('#scrollingItem').outerHeight();
          console.log(windowHeight, header, roomData);

          if (windowHeight > header + roomData) {
            console.log('Height modification required');
            this.fullscreenView = true;
          } else {
            console.log('Height modification not required');
            this.fullscreenView = false;
          }
        }, 1000);
      }
    } else {
      this.roomImageList = [];
      this.roomList = [];
      this.filteredItems = [];
      this.roomList1 = [];
      this.PreloaderService.sendData({ value: 'No preload', status: false });
      this.hasInvalidDates = true;
      this.invalidDate = true;
      this.errorPopup =
        this.rGuestBookMessages?.rooms.roomsPageInvalidDateMessage ||
        'Please select Arrival and Departure and click Refine Search to View Rooms.';
      setTimeout(() => {
        var windowHeight = $(window).height();
        var header = $('#headerItem').outerHeight();
        var roomData = $('#scrollingItem').outerHeight();
        console.log(windowHeight, header, roomData);

        if (windowHeight > header + roomData) {
          console.log('Height modification required');
          this.fullscreenView = true;
        } else {
          console.log('Height modification not required');
          this.fullscreenView = false;
        }
      }, 1000);
    }
  }
  casinoNumberTrigger(casinoNumber) {
    if (this.baseCasino != casinoNumber) {
      this.validateCasino = true;
    } else {
      this.validateCasino = false;
    }
  }
  displayOfferDetails(OfferCode) {
    $('.offer_filter').css('display', 'block');
  }
  displayOfferDetailsBelow(OfferCode) {
    $('.offer_filter_below').css('display', 'block');
  }
  closeOffers() {
    $('.offer_filter').css('display', 'none');
  }
  closeOffersbelow() {
    $('.offer_filter_below').css('display', 'none');
  }
  private processOffer = (offers) => {
    if (offers.Success) {
      if (offers.offers.length > 0) {
        this.checkinBlockDays = {};
        this.checkinBlockDays.offerName = offers.offers[0].offer;

        this.selectedOffer = offers.offers[0];
        if (this.getCasinoOfferAfterLogin)
          if (this.offerCode != offers.offers[0].offer) {
            this.offerCode = offers.offers[0].offer;
            if (this.rGuestBookRoutePermissions?.functionalPermissions?.encryptOfferCodeinURL)
              this.offerCode = this.cryptoConvert.convertOfferCode(this.offerCode, 'encrypt');
            if (this.AppInitializer?.multiGuestType) {
              let parameterObj = {};
              this.AppInitializer?.guestTypeLimit.forEach((element) => {
                if (element['selectedValue'] && Number(element['selectedValue']) > 0 && element['key'] !== 'adults') {
                  parameterObj[element['key']] = element['selectedValue'];
                }
              });
              this.router.navigate(
                [
                  'wbe/room',
                  this.tenantId,
                  this.propertyId,
                  this.arrDate,
                  this.depDate,
                  this.offerCode,
                  this.AppInitializer?.guestTypeLimit[this.adultsValue].selectedValue
                    ? this.AppInitializer?.guestTypeLimit[this.adultsValue].selectedValue
                    : 1,
                ],
                { queryParams: parameterObj }
              );
            } else {
              this.router.navigate(['wbe/room', this.tenantId, this.propertyId, this.arrDate, this.depDate, this.offerCode, this.selected]);
            }
          } else {
            this.getRooms();
          }
      } else if (offers.blockedOffers.length > 0) {
        this.checkinBlockDays = {};
        this.checkinBlockDays.offerName = offers.blockedOffers[0].offer;
        this.selectedOffer = offers.blockedOffers[0];
        this.getRooms();
      }
    } else {
      if (this.getCasinoOfferAfterLogin) this.getRooms();
    }
  };
  //Venetian TS changes
  private restrictDatesOffer() {
    const currentOfferDetails = this.validateloyaltyService.offerDateRangeDetails.find((offer) => {
      return offer.offerCode === this.offerCode;
    });
    if (typeof currentOfferDetails !== 'undefined' && currentOfferDetails.startDate && currentOfferDetails.endDate) {
      // code to restrict offer dates based on offer selected start date and end date
      let yyyy = currentOfferDetails.startDate.slice(0, 4);
      let mm = currentOfferDetails.startDate.slice(5, 7);
      if (mm > 0) mm = mm - 1;
      let dd = currentOfferDetails.startDate.slice(8, 10);
      let startDate = new Date(yyyy, mm, dd);
      if (moment(startDate).isAfter(moment(this.minDate))) {
        this.minDate = startDate;
      }
      yyyy = currentOfferDetails.endDate.slice(0, 4);
      mm = currentOfferDetails.endDate.slice(5, 7);
      if (mm > 0) mm = mm - 1;
      dd = currentOfferDetails.endDate.slice(8, 10);
      let endDate = new Date(yyyy, mm, dd);
      const dateFormat = moment.localeData(this.dateFunctionConfig?.locale).longDateFormat('L');
      this.bsConfig = Object.assign({
        containerClass: this.colorTheme,
        displayMonths: 1,
        showWeekNumbers: false,
        rangeInputFormat: dateFormat,
        rangeSeparator: ' - ',
        minDate: this.minDate,
        maxDate: endDate,
      });
    }
  }
  //Venetian TS changes
  processConfig(data) {
    if (data == null || !data.Success) {
      data.service = 'Propery Config service';
      this.PreloaderService.sendData({ value: 'No preload', status: false });
      this.MaintenanceService.putMaintenanceData(data);
      this.router.navigate(['/wbe/maintenance/' + this.tenantId + '/' + this.propertyId]);
    } else {
      this.maxNightsAllowed = data.maxNightsAllowed;
      let localDate = data.currentHotelDate;
      let yyyy = data.currentHotelDate.slice(0, 4);
      let mm = data.currentHotelDate.slice(5, 7);
      if (mm > 0) mm = mm - 1;
      let dd = data.currentHotelDate.slice(8, 10);
      this.minDate = new Date(yyyy, mm, dd);
    }
  }

  datePickerHidden() {
    if (this.rGuestBookRoutePermissions?.functionalPermissions?.enableAutoSearch && this.dateValueChanged) {
      this.refineSearch();
    }
  }

  datePickerOpened() {
    this.dateValueChanged = false;
  }

  validatedates(selectedDate) {
    this.dateValueChanged = true;
    let ArrDate;
    let DepDate;
    if (Array.isArray(selectedDate)) {
      if (selectedDate.length > 1) {
        let ArrivalDate: Date = selectedDate[0];
        let DepartureDate: Date = selectedDate[1];
        ArrivalDate = new Date(ArrivalDate);
        ArrDate = this.getDate(ArrivalDate);
        DepartureDate = new Date(DepartureDate);
        DepDate = this.getDate(DepartureDate);
        let outArrivalDate = ArrDate;
        let outDepartureDate = ArrDate;
        var timeDiff = Math.abs(ArrivalDate.getTime() - DepartureDate.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (this.maxNightsAllowed != 0 && diffDays > +this.maxNightsAllowed) {
          if (this.roomList.length > 0) {
            let errordate = this.rGuestBookMessages?.rooms.roomMessage4 + this.maxNightsAllowed + ' day(s) ';
            this.toastr.error(errordate);
          }
        } else {
          this.backupDate = selectedDate;
          //Google Analytics triggers
          this.googleAnalyticsEventsService.eventEmitter(
            'offer_searched',
            'room',
            'offer_arr_dep_searched',
            `Offer Code -${this.offerCode}, Arr/Dep Date -${moment(ArrDate, 'YYYY-MM-DD').format('MM/DD/YYYY')}/${moment(
              DepDate,
              'YYYY-MM-DD'
            ).format('MM/DD/YYYY')}, Casino Id- ${this.validateloyaltyService.playerDetails?.casinoNumber || 'NA'}`
          );
        }
        if (DepDate < ArrDate) {
          this.initialValue = this.backupDate;
          this.formatDates();
          let errordate = this.rGuestBookMessages?.rooms.roomMessage1;
          this.errorPopup = errordate;
          //this.toastr.error(errordate);
        } else if (moment(DepDate).isSame(moment(ArrDate))) {
          this.initialValue = this.backupDate;
          this.formatDates();
          let errordate = this.rGuestBookMessages?.rooms.arrDepSameErrorMessage || 'Arrival Date and Departure Date should not be same';
          this.errorPopup = errordate;
        } else if (this.validateOffsetDaysOverlap(ArrivalDate, DepartureDate) == true) {
          let errordate =
            this.rGuestBookMessages?.rooms.offsetDaysErrorMessage ||
            'Dates overlap unavailable dates. Please select different Arrival and Departure Date and Refine Search.';
          this.errorPopup = errordate;
        } else {
          if (this.invalidDate) {
            this.invalidDate = false;
            this.refineSearch('invalid');
          }
        }
      }
    }
  }
  fetchValues(detail) {
    const array = [];
    let startValue = 0;
    if (detail.key === 'adults') {
      startValue = 1;
    } else {
      startValue = 0;
    }
    for (let i = startValue; i <= detail.maxCount; i++) {
      array.push(i);
    }
    return array;
  }
  validateArrDate(arrDate) {
    let arrDate1;
    let depDate1;
    arrDate1 = moment(arrDate).format('YYYY-MM-DD');
    depDate1 = this.IEdeparture ? moment(this.IEdeparture).format('YYYY-MM-DD') : '';
    let arr = arrDate1.split('-');
    let dep = depDate1 ? depDate1.split('-') : '';
    this.initialValue = [new Date(+arr[0], +arr[1] - 1, +arr[2]), dep ? new Date(+dep[0], +dep[1] - 1, +dep[2]) : ''];
    this.formatDates();
    if (this.IEdeparture && this.rGuestBookRoutePermissions?.functionalPermissions?.enableAutoSearch) {
      this.refineSearch();
    }
    if (!this.rGuestBookRoutePermissions?.functionalPermissions?.enableAutoSearch) {
      setTimeout(() => {
        this.depDatePicker.open();
      }, 500);
    }
  }
  validateDepDate(depDate) {
    let arrDate2;
    let depDate2;
    arrDate2 = this.IEarrival ? moment(this.IEarrival).format('YYYY-MM-DD') : '';
    depDate2 = moment(depDate).format('YYYY-MM-DD');
    let arr = arrDate2 ? arrDate2.split('-') : '';
    let dep = depDate2.split('-');
    this.initialValue = [arr ? new Date(+arr[0], +arr[1] - 1, +arr[2]) : '', new Date(+dep[0], +dep[1] - 1, +dep[2])];
    this.formatDates();
    if (this.IEarrival && this.rGuestBookRoutePermissions?.functionalPermissions?.enableAutoSearch) {
      this.refineSearch();
    }
    //Google Analytics triggers

    this.googleAnalyticsEventsService.eventEmitter(
      'offer_searched',
      'room',
      'offer_arr_dep_searched',
      `Offer Code -${this.offerCode},Arr/Dep Date -${moment(arrDate2, 'YYYY-MM-DD').format('MM/DD/YYYY')}/${moment(
        depDate2,
        'YYYY-MM-DD'
      ).format('MM/DD/YYYY')}, Casino Id - ${this.validateloyaltyService.playerDetails?.casinoNumber || 'NA'}`
    );
  }
  validateArrDate1(arrDate) {
    let arrDate1;
    let depDate1;
    arrDate1 = moment(arrDate).format('YYYY-MM-DD');
    depDate1 = this.IEdeparture ? moment(this.IEdeparture).format('YYYY-MM-DD') : '';
    let arr = arrDate1.split('-');
    let dep = depDate1 ? depDate1.split('-') : '';
    this.initialValue = [new Date(+arr[0], +arr[1] - 1, +arr[2]), dep ? new Date(+dep[0], +dep[1] - 1, +dep[2]) : ''];
    this.formatDates();
    if (this.IEdeparture && this.rGuestBookRoutePermissions?.functionalPermissions?.enableAutoSearch) {
      this.refineSearch();
    }
    if (!this.rGuestBookRoutePermissions?.functionalPermissions?.enableAutoSearch) {
      setTimeout(() => {
        this.depDatePicker1.open();
      }, 500);
    }
  }
  validateDepDate1(depDate) {
    let arrDate2;
    let depDate2;
    arrDate2 = this.IEarrival ? moment(this.IEarrival).format('YYYY-MM-DD') : '';
    depDate2 = moment(depDate).format('YYYY-MM-DD');
    let arr = arrDate2 ? arrDate2.split('-') : '';
    let dep = depDate2.split('-');
    //Google Analytics triggers

    this.googleAnalyticsEventsService.eventEmitter(
      'offer_searched',
      'room',
      'offer_arr_dep_searched',
      `Offer Code -${this.offerCode}, Arr/Dep Date -${moment(arrDate2, 'YYYY-MM-DD').format('MM/DD/YYYY')}/${moment(
        depDate2,
        'YYYY-MM-DD'
      ).format('MM/DD/YYYY')}, Casino Id - ${this.validateloyaltyService.playerDetails?.casinoNumber || 'NA'}`
    );

    if (this.IEarrival && this.rGuestBookRoutePermissions?.functionalPermissions?.enableAutoSearch) {
      this.refineSearch();
    }
    this.initialValue = [arr ? new Date(+arr[0], +arr[1] - 1, +arr[2]) : '', new Date(+dep[0], +dep[1] - 1, +dep[2])];
    this.formatDates();
  }
  getDate(UnformattedDate: Date) {
    let mm, dd, yyyy;
    mm = UnformattedDate.getMonth() + 1;
    mm = this.checkFormat(mm);
    dd = UnformattedDate.getDate();
    dd = this.checkFormat(dd);
    yyyy = UnformattedDate.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
  }

  isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
  }

  bookFromTop(room) {
    this.booktheRoom(room);
  }

  formatDates() {
    const dateFormat = moment.localeData(this.dateFunctionConfig?.locale).longDateFormat('L');
    this.bsConfig = Object.assign({
      containerClass: this.colorTheme,
      displayMonths: 1,
      showWeekNumbers: false,
      rangeInputFormat: dateFormat,
      rangeSeparator: ' - ',
    });
  }

  showDetails(room, i) {
    if (this.previousRoom && this.previousRoom != room.roomName) {
      this.showMore = false;

      this.googleAnalyticsEventsService.eventEmitter(
        'room_details',
        'room',
        'room_details_closed',
        `OfferCode/RoomName -${this.offerCode}/${this.previousRoom}, Casino Id - ${
          this.validateloyaltyService.playerDetails?.casinoNumber || 'NA'
        }`
      );

      this.googleAnalyticsEventsService.eventEmitter(
        'room_details',
        'room',
        'room_details_viewed',
        `OfferCode/RoomName -${this.offerCode}/${room.roomName}, Casino Id - ${
          this.validateloyaltyService.playerDetails?.casinoNumber || 'NA'
        }`
      );
      this.googleAnalyticsEventsService.viewRoomItem(
        room,
        i,
        this.offerCode,
        this.validateloyaltyService?.playerDetails?.casinoNumber,
        this.ConfigService?.PropertyData?.currencyCode,
        this.ConfigService?.configDetailsData.propertyName,
        this.propertyId
      );
      this.previousRoom = room.roomName;
    } else {
      this.previousRoom = room.roomName;
      this.googleAnalyticsEventsService.eventEmitter(
        'room_details',
        'room',
        'room_details_viewed',
        `OfferCode/RoomName -${this.offerCode}/${room.roomName}, Casino Id - ${
          this.validateloyaltyService.playerDetails?.casinoNumber || 'NA'
        }`
      );
      this.googleAnalyticsEventsService.viewRoomItem(
        room,
        i,
        this.offerCode,
        this.validateloyaltyService?.playerDetails?.casinoNumber,
        this.ConfigService?.PropertyData?.currencyCode,
        this.ConfigService?.configDetailsData.propertyName,
        this.propertyId
      );
    }

    this.scrollfix = i;
    this.room = room;

    let isThatEven = this.isEven(i);
    // let roomsCount = this.roomList.length;
    let roomsCount = this.filteredItems.length;
    for (let p = 0; p < this.filteredItems.length; p++) {
      $('#showArrow' + p).css('display', 'none');
    }
    $('#showArrow' + i).css('display', 'block');
    if (isThatEven && i == this.filteredItems.length - 1) {
      if (this.windowWidth <= 980 && roomsCount > 1) {
        i++;
      }
    } else if (isThatEven && roomsCount > 1) {
      i++;
    }
    if (this.windowWidth <= 980) {
      if (isThatEven && roomsCount > 1) {
        i--;
      }
    }
    this.selectedTab = room;
    $('#detailstab').insertAfter($('#room-panel' + i));
    $('#detailstab').addClass('detailstablist col-xs-12 col-sm-12 col-md-12 col-lg-12');
    if (!this.details_tab) this.details_tab = true;
    this.selectedTabvalue = 0;
    setTimeout(() => {
      var element = document.getElementById('detailstab');
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      $('#detailstab').addClass('animated pulse');
      var windowHeight = $(window).height();
      var header = $('#headerItem').outerHeight();
      var roomData = $('#scrollingItem').outerHeight();
      console.log(windowHeight, header, roomData);

      if (windowHeight > header + roomData) {
        console.log('Height modification required');
        this.fullscreenView = true;
      } else {
        console.log('Height modification not required');
        this.fullscreenView = false;
      }
    }, 100);
    var IEorEdge = this.detectIE();
    setTimeout(() => {
      if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) || IEorEdge) {
        console.log('moving...');
        $('html, body').animate({ scrollTop: $(window).scrollTop() - 100 + 'px' }, 1000);
      }
    }, 500);
  }
  contains = function (needle) {
    var findNaN = needle !== needle;
    var indexOf;

    if (!findNaN && typeof Array.prototype.indexOf === 'function') {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function (needle) {
        var i = -1,
          index = -1;

        for (i = 0; i < this.length; i++) {
          var item = this[i];

          if ((findNaN && item !== item) || item === needle) {
            index = i;
            break;
          }
        }

        return index;
      };
    }

    return indexOf.call(this, needle) > -1;
  };
  isEven(n) {
    return n % 2 == 0;
  }
  booktheRoom(room) {
    if (localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'transactionID') !== undefined) {
      localStorage.setItem(
        this.tenantId + '-' + this.propertyId + '-' + 'transactionID',
        JSON.stringify(this.AppInitializer?.transactionID)
      );
    }

    this.getAnalyticsData(room);

    this.googleAnalyticsEventsService.eventEmitter(
      'select_room',
      'room',
      'room_selected',
      `OfferCode/RoomName -${this.offerCode}/${room.roomName}, Casino Id - ${
        this.validateloyaltyService.playerDetails?.casinoNumber || 'NA'
      }`
    );

    let taxesAndFees;

    try {
      taxesAndFees = room.quoteTotalTax + room.recurringChargesTotal + room.resortFeeTotal;
    } catch (error) {
      taxesAndFees = room.quoteTotalTax;
    }

    // let totalGuestCount = 0;
    // this.AppInitializer?.guestDetails.forEach(element => {
    //   if(element.selectedValue){
    //   totalGuestCount += Number(element.selectedValue);
    //   }
    // });

    //Google Tag Manager Data Layer Push
    if (this.AppInitializer?.multiGuestType) {
      this.googleAnalyticsEventsService.pushGTAToDataLayer({
        event: 'roomPageData',
        value: room.quoteGrandTotal,
        transaction_id: 'NA',
        casinoId: this.validateloyaltyService.playerDetails?.casinoNumber || 'NA',
        emailAddress: this.validateloyaltyService.playerDetails?.emailAddress || 'NA',
        'Number of Nights': moment(this.depDate).diff(moment(this.arrDate), 'days'),
        Adults: this.AppInitializer?.multiGuestType
          ? this.AppInitializer?.guestTypeLimit[this.adultsValue].selectedValue
            ? this.AppInitializer?.guestTypeLimit[this.adultsValue].selectedValue
            : 1
          : this.selected,
        'Check In Date': this.arrDate,
        'Check Out Date': this.depDate,
        'Total Revenue': room.quoteGrandTotal,
        'Room Type': room.roomType ? room.roomType : 'NA',
        Children: this.AppInitializer?.guestTypeLimit[this.childValue]
          ? this.AppInitializer?.guestTypeLimit[this.childValue].selectedValue
            ? this.AppInitializer?.guestTypeLimit[this.childValue].selectedValue
            : 0
          : 0,
        Juniors: this.AppInitializer?.guestTypeLimit[this.juniorValue]
          ? this.AppInitializer?.guestTypeLimit[this.juniorValue].selectedValue
            ? this.AppInitializer?.guestTypeLimit[this.juniorValue].selectedValue
            : 0
          : 0,
        Infants: this.AppInitializer?.guestTypeLimit[this.infantsValue]
          ? this.AppInitializer?.guestTypeLimit[this.infantsValue].selectedValue
            ? this.AppInitializer?.guestTypeLimit[this.infantsValue].selectedValue
            : 0
          : 0,
        'Disable people': this.AppInitializer?.guestTypeLimit[this.disablePeopleValue]
          ? this.AppInitializer?.guestTypeLimit[this.disablePeopleValue].selectedValue
            ? this.AppInitializer?.guestTypeLimit[this.disablePeopleValue].selectedValue
            : 0
          : 0,
        'Room Revenue': room.roomTotal,
        'Taxes and Fees': taxesAndFees,
        'Promo Code': this.offerCode,
        'Discount Amount': 'NA',
        'Reservation ID': 'NA',
        Currency: this.ConfigService?.PropertyData?.currencyCode,
        'Rate Plan': this.offerCode,
        'Property Booked': this.ConfigService?.configDetailsData.propertyName,
      });
    } else {
      this.googleAnalyticsEventsService.pushGTAToDataLayer({
        event: 'roomPageData',
        value: room.quoteGrandTotal,
        transaction_id: 'NA',
        casinoId: this.validateloyaltyService.playerDetails?.casinoNumber || 'NA',
        emailAddress: this.validateloyaltyService.playerDetails?.emailAddress || 'NA',
        'Number of Nights': moment(this.depDate).diff(moment(this.arrDate), 'days'),
        Adults: this.selected,
        'Check In Date': this.arrDate,
        'Check Out Date': this.depDate,
        'Total Revenue': room.quoteGrandTotal,
        'Room Type': room.roomType ? room.roomType : 'NA',
        Children: 0,
        'Room Revenue': room.roomTotal,
        'Taxes and Fees': taxesAndFees,
        'Promo Code': this.offerCode,
        'Discount Amount': 'NA',
        'Reservation ID': 'NA',
        Currency: this.ConfigService?.PropertyData?.currencyCode,
        'Rate Plan': this.offerCode,
        'Property Booked': this.ConfigService?.configDetailsData.propertyName,
      });
    }

    localStorage.setItem(this.tenantId + '-' + this.propertyId + '-' + 'AnalyticsId', this.AppInitializer?.userID);
    if (this.rGuestBookRoutePermissions?.routePermissions.enhancements) {
      let data = {
        status: true,
        value: this.rGuestBookMessages?.rooms.roomMessage6,
      };
      this.PreloaderService.sendData(data);
      let guest;
      if (this.AppInitializer?.multiGuestType) {
        guest = this.AppInitializer?.guestTypeLimit;
      } else {
        guest = this.selected;
      }
      this.enhance
        .getConfigDetails(this.offerCode, this.arrDate, this.depDate, guest, this.AppInitializer?.multiGuestType, room.roomCode)
        .subscribe(
          (result) => {
            this.ProcessData(result, room);
          },
          (error) => {
            this.ProcessData(error, room);
          }
        );
    } else {
      room.hasEnhancement = false;
      localStorage.setItem(this.tenantId + '-' + this.propertyId + '-' + 'validEnhancedata', 'false');
      let roomDetail = new Roomdata(
        room.expandedDescription,
        room.blockRoom,
        room.compDays,
        room.days,
        room.hasComp,
        room.minRate,
        room.minRateTax,
        room.thead,
        room.tbody,
        room.roomsImages,
        room.previousPlayerStay,
        room.wing,
        room.roomType,
        room.roomCode,
        room.roomName,
        room.cancellationPolicy,
        room.depositPolicy,
        room.rateSnapshot,
        room.roomTotal,
        room.roomTaxTotal,
        room.recurringChargesTotalTax,
        room.quoteGrandTotal,
        room.roomTypeAvailable,
        room.roomSequence,
        room.resortFeeTotalTax,
        room.recurringChargesTotal,
        room.cancelDescription,
        room.depositDueDate,
        room.resortFeeTotal,
        room.depositAmountDue,
        room.cancelAmountDue,
        room.cancelDueDate,
        room.quoteTotalTax,
        room.depositDescription,
        room.quoteTotal,
        room.hasEnhancement,
        room.recurringChargesEnhancementTotal,
        room.resortFeeEnhancementTotal,
        room.roomSoldOut,
        this.showRemainingRoomsCount,
        room.isPackage
      );
      roomDetail.thead.forEach((element) => {
        if (element == 'roomTheadResortFee') {
          roomDetail['hasResortFee'] = true;
        }
        if (element == 'roomTheadOtherFee') {
          roomDetail['hasOtherFee'] = true;
        }
      });
      this.BookService.putValue(
        roomDetail,
        this.arrDate,
        this.depDate,
        this.casinoNumber,
        this.offerCode,
        this.thead,
        this.AppInitializer?.multiGuestType,
        this.AppInitializer?.multiGuestType ? this.AppInitializer?.guestTypeLimit : this.selected,
        '',
        this.selectedOffer,
        this.tenantId,
        this.propertyId,
        ''
      );
      this.preloadData = false;
      this.router.navigate(['wbe/book/' + this.tenantId + '/' + this.propertyId]);
    }
  }

  getAnalyticsData(room): void {
    let data: EventData = {
      SKU: `SKU_${room?.rateSnapshot[0]?.ratePlanCode}_${room?.roomCode}_${room?.roomName}_${room?.rateSnapshot[0]?.date}_days_${room?.days}`,
      affiliation: this.ConfigService?.configDetailsData?.propertyName,
      brand_category: this.propertyId,
      cart_type: 'room',
      coupon: this.offerCode || room?.rateSnapshot[0]?.ratePlanCode,
      currency: this.ConfigService?.PropertyData?.currencyCode,
      price: room?.quoteTotal,
      quantity: 1,
      tax: room?.quoteTotalTax,
      value: room?.quoteTotal,
      itemName: `${room?.roomName}`,
      item_brand: this.tenantId,
    };

    this.googleAnalyticsEventsService.addToCartGA4(data, this.validateloyaltyService.playerDetails?.casinoNumber);
  }
  ProcessData(data, room) {
    let tenant = this.tenantId;
    let property = this.propertyId;
    if (data.Success == false) {
      room.hasEnhancement = false;
      room.recurringChargesEnhancementTotal = 0;
      room.roomSoldOut = false;
      room.resortFeeEnhancementTotal = 0;
      if (localStorage.getItem(tenant + '-' + property + '-' + 'validEnhancedata')) {
        let value = localStorage.getItem(tenant + '-' + property + '-' + 'validEnhancedata');
        if (value == 'false') {
          localStorage.setItem(tenant + '-' + property + '-' + 'validEnhancedata', 'false');
        } else {
          localStorage.setItem(tenant + '-' + property + '-' + 'validEnhancedata', 'true');
        }
      } else localStorage.setItem(tenant + '-' + property + '-' + 'validEnhancedata', 'false');
    } else {
      if (data.enhancements.length > 0) {
        room.hasEnhancement = true;
        room.recurringChargesEnhancementTotal = 0;
        room.resortFeeEnhancementTotal = 0;
        room.roomSoldOut = false;
        localStorage.setItem(tenant + '-' + property + '-' + 'validEnhancedata', 'true');
      } else {
        room.hasEnhancement = false;
        room.recurringChargesEnhancementTotal = 0;
        room.resortFeeEnhancementTotal = 0;
        room.roomSoldOut = false;
        localStorage.setItem(tenant + '-' + property + '-' + 'validEnhancedata', 'false');
      }
    }
    let enhanceData = data;
    enhanceData.roomName = room.roomName;
    enhanceData.offerName = this.selectedOffer.offerDescription;
    enhanceData.offerCode = this.offerCode;
    enhanceData.ArrivalDate = this.arrDate;
    enhanceData.DepartureDate = this.depDate;

    let roomDetail = new Roomdata(
      room.expandedDescription,
      room.blockRoom,
      room.compDays,
      room.days,
      room.hasComp,
      room.minRate,
      room.minRateTax,
      room.thead,
      room.tbody,
      room.roomsImages,
      room.previousPlayerStay,
      room.wing,
      room.roomType,
      room.roomCode,
      room.roomName,
      room.cancellationPolicy,
      room.depositPolicy,
      room.rateSnapshot,
      room.roomTotal,
      room.roomTaxTotal,
      room.recurringChargesTotalTax,
      room.quoteGrandTotal,
      room.roomTypeAvailable,
      room.roomSequence,
      room.resortFeeTotalTax,
      room.recurringChargesTotal,
      room.cancelDescription,
      room.depositDueDate,
      room.resortFeeTotal,
      room.depositAmountDue,
      room.cancelAmountDue,
      room.cancelDueDate,
      room.quoteTotalTax,
      room.depositDescription,
      room.quoteTotal,
      room.hasEnhancement,
      room.recurringChargesEnhancementTotal,
      room.resortFeeEnhancementTotal,
      room.roomSoldOut,
      this.showRemainingRoomsCount,
      room.isPackage
    );
    roomDetail.thead.forEach((element) => {
      if (element == 'roomTheadResortFee') {
        roomDetail['hasResortFee'] = true;
      }
      if (element == 'roomTheadOtherFee') {
        roomDetail['hasOtherFee'] = true;
      }
    });
    this.BookService.putValue(
      roomDetail,
      this.arrDate,
      this.depDate,
      this.casinoNumber,
      this.offerCode,
      this.thead,
      this.AppInitializer?.multiGuestType,
      this.AppInitializer?.multiGuestType ? this.AppInitializer?.guestTypeLimit : this.selected,
      '',
      this.selectedOffer,
      this.tenantId,
      this.propertyId,
      enhanceData
    );
    // if(data.Success) {
    this.preloadData = false;
    if (localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'validEnhancedata') == 'true')
      this.router.navigate(['wbe/stayenhance/' + this.tenantId + '/' + this.propertyId]);
    else {
      this.router.navigate(['wbe/book/' + this.tenantId + '/' + this.propertyId]);
    }
  }
  closeTab(closeTab) {
    this.closeDetailTab(closeTab);
    setTimeout(() => {
      var windowHeight = $(window).height();
      var header = $('#headerItem').outerHeight();
      var roomData = $('#scrollingItem').outerHeight();
      console.log(windowHeight, header, roomData);

      if (windowHeight > header + roomData) {
        console.log('Height modification required');
        this.fullscreenView = true;
      } else {
        console.log('Height modification not required');
        this.fullscreenView = false;
      }
    }, 1000);
  }
  closeDetailTab(closeTab) {
    this.previousRoom = '';
    this.closedvalue = true;
    this.previousIndex = 0;
    this.selectedTabvalue = 0;
    $('#showArrow' + this.scrollfix).css('display', 'none');
    $('#detailstab').insertAfter($('#scrollingItem'));
    this.details_tab = false;
  }
  passTheValue() {
    this.closedvalue = true;
    this.previousIndex = 0;
    this.selectedTabvalue = 0;
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      200
    );

    setTimeout(() => {
      $('html').css('overflow', 'hidden');
      //  $('body').css('overflow', 'hidden');
    }, 1000);

    $('#showArrow' + this.scrollfix).css('display', 'none');
    $('#detailstab').insertAfter($('#scrollingItem'));
    setTimeout(() => {
      var windowHeight = $(window).height();
      var header = $('#headerItem').outerHeight();
      var roomData = $('#scrollingItem').outerHeight();
      console.log(windowHeight, header, roomData);

      if (windowHeight > header + roomData) {
        console.log('Height modification required');
        this.fullscreenView = true;
      } else {
        console.log('Height modification not required');
        this.fullscreenView = false;
      }
    }, 100);
    this.details_tab = false;
    this.triggerSidebar = true;
    if (this.casinoNumber && this.casinoValidateHide) {
      this.child.casinoNumber = this.casinoNumber;
      this.child.casinoNumberpanel = this.casinoNumber;
      this.child.searchOffers('sideNav');
    } else {
      this.child.casinoNumber = '';
      this.child.casinoNumberpanel = '';
      this.child.searchOffers('sideNav');
    }
  }
  passThenumber() {
    this.closedvalue = true;
    this.previousIndex = 0;
    this.selectedTabvalue = 0;
    this.offersTab = 1;
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      800
    );
    $('html').css('overflow', 'hidden');
    // $('body').css('overflow', 'hidden');

    $('#showArrow' + this.scrollfix).css('display', 'none');
    $('#detailstab').insertAfter($('#scrollingItem'));
    setTimeout(() => {
      var windowHeight = $(window).height();
      var header = $('#headerItem').outerHeight();
      var roomData = $('#scrollingItem').outerHeight();
      console.log(windowHeight, header, roomData);

      if (windowHeight > header + roomData) {
        console.log('Height modification required');
        this.fullscreenView = true;
      } else {
        console.log('Height modification not required');
        this.fullscreenView = false;
      }
    }, 100);
    this.details_tab = false;
    this.triggerSidebar = true;
    this.child.casinoNumber = this.casinoNumber;
    this.child.casinoNumberpanel = this.casinoNumber;
    this.child.getCasinoPlayer(this.casinoNumber);
    this.child.searchOffers('sideNav');
  }
  getDates(UnformattedDate: Date) {
    let mm, dd, yyyy;
    mm = UnformattedDate.getMonth() + 1;
    mm = this.checkFormat(mm);
    dd = UnformattedDate.getDate();
    dd = this.checkFormat(dd);
    yyyy = UnformattedDate.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
  }
  checkFormat(i) {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  }
  toggleSidebar(casinoNumber) {
    this.triggerSidebar = !this.triggerSidebar;
  }
  closeSidebar() {
    $('html').css('overflow', 'auto');
    // $('body').css('overflow', 'auto');
    this.triggerSidebar = false;
  }

  openCanellationDepositPolicy(selectedRoom) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.panelClass = 'overflowAutoClass';
    dialogConfig.maxWidth = 600;
    dialogConfig.data = {
      depositPolicy: selectedRoom.depositDescription,
      depositAmount: selectedRoom.depositAmountDue,
      cancellationPolicy: selectedRoom.cancelDescription,
      cancellationDueDate: selectedRoom.cancelDueDate,
      cancellationAmount: selectedRoom.cancelAmountDue,
    };
    const dialogRef = this.dialog.open(PolicyModalComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
      this.depositAndCancellationBtn['_elementRef'].nativeElement.classList.remove('cdk-program-focused', 'cdk-focused');
      setTimeout(() => {
        $('.modify_filter_title').trigger('click');
      }, 1000);
    });

    this.googleAnalyticsEventsService.eventEmitter(
      'deposit_and_cancellation_policy_button',
      'room',
      'depositAndCancellationViewed',
      `Offer Code - ${this.offerCode}, Casino Id - ${this.validateloyaltyService?.playerDetails?.casinoNumber || 'NA'}`
    );
    // this._shared.policyBoxes(selectedRoom);
  }
  errorPlayerCardHandler(event) {
    console.debug(event);
    event.target.src = ADMIN_CONSTANT.DEFAULT_IMAGE_PATH.defaultCasinoPlayerCardImage;
  }
  errorRoomImageHandler(room, event, roomCode, imageName, isListIndex, index) {
    if (this.rGuestBookRoutePermissions?.functionalPermissions?.blockDefaultImage) {
      if (!isListIndex) {
        this.selectedTab.roomsImages.splice(index, 1);
      } else {
        event.target.src =
          (this.defaultRoomImageURL || 'https://rguestbookexpressprod.blob.core.windows.net/config/assets/images/default.jpg') +
          '?' +
          this.ConfigService?.azureBlobTokenKey;
      }
    } else {
      event.target.src =
        (this.defaultRoomImageURL || 'https://rguestbookexpressprod.blob.core.windows.net/config/assets/images/default.jpg') +
        '?' +
        this.ConfigService?.azureBlobTokenKey;
    }
    if (this.propertyId == 'venetian-book') {
      let indexValue = this.ConfigService?.PropertyData?.TimeZone ? this.ConfigService?.PropertyData?.TimeZone.indexOf('UTC') : 'NA';
      try {
        if (indexValue != 'NA' && indexValue != -1) {
          indexValue = Number(indexValue) + 3;
          let substring = this.ConfigService?.PropertyData?.TimeZone.substring(indexValue, indexValue + 5);
          substring = substring.replace(':', '.');
          let d = new Date();
          let utc = d.getTime() + d.getTimezoneOffset() * 60000;
          let nd = new Date(utc + 3600000 * Number(substring));
          this.propertyTime = nd.toLocaleString();
        } else {
          this.propertyTime = 'NA';
        }
      } catch {
        this.propertyTime = 'NA';
      }
      let image = imageName ? imageName : 'NA';

      this.googleAnalyticsEventsService.eventEmitter(
        'image_not_found',
        'room',
        'image_load',
        `Room Code -${roomCode}_${image}_${this.propertyTime}, Casino Id. -${
          this.validateloyaltyService?.playerDetails?.casinoNumber || 'NA'
        }, OfferCode - ${this.offerCode} `,
        1
      );
    }
  }
  openCompareModal() {
    this.dialog.open(this.compareRooms, {
      panelClass: 'my-full-screen-dialog',
    });
  }
  openCalendarModal() {
    let data = {
      arrivalDate: this.arrDate,
      departureDate: this.depDate,
      offerCode: this.offerCode,
      guestCount: this.selected,
      rooms: this.roomList,
    };
    this._shared.roomChange(data);
    setTimeout(() => {
      let offerCodeData;
      if (this.rGuestBookRoutePermissions?.functionalPermissions?.encryptOfferCodeinURL)
        offerCodeData = this.cryptoConvert.convertOfferCode(this.offerCode, 'encrypt');
      else offerCodeData = this.offerCode;
      this.router.navigate(['/wbe/calendar/' + this.tenantId + '/' + this.propertyId + '/' + offerCodeData]);
    }, 500);
  }

  validateCasinoPlayer(casinoNumber) {
    if (
      typeof localStorage.getItem(this.tenantId + '-' + this.propertyId + '-userLoggedIn') != 'undefined' &&
      JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-userLoggedIn')) != null
    ) {
      let logindetials = JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-userLoggedIn'));
    } else if (this.AppInitializer?.PropertyData?.casinoValReq) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.position = {
        top: '10px',
      };
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.data = {
        casinoNumber: casinoNumber,
      };
      const dialogRef = this.dialog.open(CpinComponent, dialogConfig);
      dialogRef.beforeClosed().subscribe((data) => {
        console.log('Dialog output:', data);
        if (data == 'success') {
          this.casinoValidateHide = true;
          this.PreloaderService.sendData({ status: true, value: this.rGuestBookMessages?.rooms.roomMessage2 });
          this.getCasinoPlayer(casinoNumber, 'Validate');
        }
      });
    } else {
      // let data = {
      //   casinoNumber: casinoNumber,
      //   token: 1
      // }
      //   localStorage.setItem(this.tenantId + '-' + this.propertyId + "-Casino", JSON.stringify(data));
      //   this.casinoValidateHide = true;
      this.getCasinoPlayer(casinoNumber, 'noValidate');
    }
  }

  public getCasinoPlayer(casinoNumber, permission) {
    var valid_casinno = /^[ A-Za-z0-9_@./#&+-]*$/;

    if (casinoNumber != '' && valid_casinno.test(casinoNumber)) {
      if (!this.AppInitializer?.PropertyData?.casinoValReq)
        this.PreloaderService.sendData({ status: true, value: this.rGuestBookMessages?.offer.offerMessage7 });
      this.casinoNumber = casinoNumber;
      this.CasinoPlayerService.getCasinoPlayerDetails(casinoNumber, this.tenantId).then(
        (result) => {
          let appendArray: any;
          appendArray = [];
          appendArray = result;
          console.log('casino Player details: ', appendArray);
          if (!appendArray.Success) {
            this.toastr.error(
              appendArray.ErrorMessage ||
                this.rGuestBookMessages.commonVerbiage.loyaltyApiNoResponseError ||
                'Something went wrong. Please try again later'
            );
            this.CpinService.loginPlayerDetails.next('default');
            this.casinoNumber = '';
            this.CasinoPlayerService.removePlayerToken();
            localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-Casino');
            localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-userLoggedIn');
            sessionStorage.removeItem(this.tenantId + '-' + this.propertyId + '-userSelectedOffer');
            this._roomList.casinoPlayerloginCall.next(false);
            this._roomList.offerSelectedfromoffersAPI.next(true);
            this.casinoValidateHide = false;
            this.PreloaderService.sendData({ value: 'No preload', status: false });
            return false;
          } else {
            this.snackbar.open(this.rGuestBookMessages?.profile.profileMessage6, '', {
              duration: 3000,
            });
            if (permission == 'noValidate') {
              let data = {
                casinoNumber: casinoNumber,
                token: 1,
              };
              localStorage.setItem(this.tenantId + '-' + this.propertyId + '-Casino', JSON.stringify(data));
              this.casinoValidateHide = true;
            }

            this.CasinoPlayerService.updateCasinoPopUp(appendArray);
            this.afterInit();
          }
          // if (!this.AppInitializer?.getcasinoValidationRequired())
          //   this.PreloaderService.sendData({ value: "No preload", status: false })
        },
        (error) => {
          if ($('#toast-container').html() == undefined) {
            this.toastr.error(this.rGuestBookMessages?.rooms.roomMessage8);
          }
          if (!this.AppInitializer?.PropertyData?.casinoValReq) this.PreloaderService.sendData({ value: 'No preload', status: false });
        }
      );
    } else {
      $('.toast-custom').hide();
      //  localStorage.removeItem(this.tenantId + '-' + this.propertyId+ '-' +"casinoItems");
      if ((casinoNumber != '' && $('#toast-container').html() == undefined) || !valid_casinno.test(casinoNumber)) {
        this.toastr.error('Invalid Casino number');
        $('.toast-custom').show();
      }
      this.casinoNumber = '';
    }
  }
  detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return true;
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return true;
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return true;
    }

    // other browser
    return false;
  }
  // getLabel(filterValue){
  //   return this.searchLabel(filterValue);
  // }
  getLabel(filterValue) {
    for (var i = 0; i < this.filters.length; i++) {
      if ('searchText' + this.filters[i].mappingField + this.filters[i].order === filterValue) {
        return this.filters[i].label;
      }
    }
  }
  getFilterValue(filterKey, filterValue) {
    for (var i = 0; i < this.filters.length; i++) {
      if ('searchText' + this.filters[i].mappingField + this.filters[i].order === filterKey) {
        if (Array.isArray(filterValue)) {
          return this.filters[i].values
            .map((val) => {
              if (filterValue.includes(val.key)) {
                return val.value;
              }
            })
            .filter(function (el) {
              return el != null;
            });
        } else if (this.filters[i].type == 'radio') {
          return this.filters[i].values
            .map((val) => {
              if (filterValue == val.key) {
                return val.value;
              }
            })
            .filter(function (el) {
              return el != null;
            });
        } else {
          return filterValue;
        }
      }
    }
  }
  searchFilterEmpty() {
    this.showFilterPanel = !Object.values(this.filtervalueobj).every((o) => {
      if (Array.isArray(o)) {
        return !o.length;
      } else {
        return o === null || o === '' || typeof o === 'undefined';
      }
    });
  }
  saveData(data) {
    this.filtervalueobj = data;
    this.searchFilterEmpty();
  }
  openBottomSheetRoomFilter(): void {
    this.emptyFilterVisibility = true;
    if (this.selectedTab) {
      this.closeDetailTab(this.selectedTab);
    }
    this.dialog.open(BottomSheetRoomFilter, {
      autoFocus: false,
      width: this.filters.length > 4 ? '800px' : '400px',
      height: 'auto',
      data: {
        rooms: this.roomList,
        comp: this.saveData.bind(this),
        filters: this.filtervalueobj,
        filterParams: this.filters,
      },
      panelClass: 'advanced-filter-container',
    });
  }
  remove(removeFilter): void {
    this.filtervalueobj[removeFilter] = '';
    this.filteredItems = this._roomList.filterRooms(this.filters, this.filtervalueobj, this.roomList);
    this.checkViewPort();
    this.searchFilterEmpty();
  }

  validateOffsetDaysOverlap(ArrivalDate: Date, DepartureDate: Date) {
    if (this.restrictDateSelection) {
      var count = this.restrictedDates.length;
      for (let i = 0; i < count; i++) {
        if (ArrivalDate < this.restrictedDates[i] && DepartureDate > this.restrictedDates[i]) {
          return true;
        }
      }
    }
  }
}
